<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate' :disabled='!isConnected'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('root.filters.contact_name') }}</label>
    <multi-select v-model='selectedContacts' :getter='getContacts' :disabled='!isConnected' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
import _multi_select from '../../shared/_infinite_multi_select'

export default {
  components: {
    'multi-select': _multi_select,
  },
  data() {
    return {
      predicate: true,
      isConnected: true,
      selectedContacts: [],
    }
  },
  computed: {
    selectedContactIds() {
      return this.selectedContacts.map(c => c.id)
    },
    predicateQuery() {
      return this.predicate ? 'filters[id_in]' : 'filters[id_not_in]'
    }
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[id_present]']
      delete newQuery['filters[id_in]']
      delete newQuery['filters[id_not_in]']

      if (!this.isConnected) {
        newQuery = Object.assign({}, newQuery, { page: 1, 'filters[id_present]': this.isConnected })
      } else {
        newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedContactIds })
      }

      this.$router.push({ query: newQuery })
    },
    getContacts(params) {
      return this.listStore.getContacts(params)
    },
  }
}
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
